export enum JuiValidationEvents {
  onFocus = 'onFocus',
  onLoad = 'onLoad'
}

export enum JuiControlSize {
  md = 'md',
  lg = 'lg',
  sm = 'sm'
}

export enum JuiControlNumberFormat {
  int = 'int',
  float = 'float'
}

export enum JuiControlNumberStyle {
  decimal = 'decimal',
  currency = 'currency',
  percent = 'percent'
}

export enum JuiControlAlign {
  left = 'left',
  right = 'right'
}
